export const getRole = (): string => {
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  return user?.role || "";
};

export const ROLES = {
  SUPER_ADMIN: "Super Admin",
  SYSTEM_ADMIN: "System Admin",
  SUPER_SUPER_ADMIN: "Super Super Admin",
    VIEWER: "Viewer", 
};

export const isViewer = (): boolean => getRole() === ROLES.VIEWER;

export const canSeeSoftDeleted = (): boolean => {
  const role = getRole();
  return (
    role === ROLES.SYSTEM_ADMIN ||
    role === ROLES.SUPER_SUPER_ADMIN ||
    role === ROLES.SUPER_ADMIN
  );
};

export const canRestoreOrHardDelete = (): boolean => {
  const role = getRole();
  return (
    role === ROLES.SYSTEM_ADMIN ||
    role === ROLES.SUPER_SUPER_ADMIN
  );
};